import request from "./request";

//受众分析
export const getAdvertiserInfo = () => request("/bi/getAdvertiserInfo", null, "POST");
export const queryAudience = (data) => request("/report/queryAudience", data, "POST");

//素材报表
export const getTag = () => request("/tag/getTag", null, "GET");
export const getDesigner = () => request("/tag/getDesigner", null, "GET");
export const materialReport = (data) => request("/report/materialReport", data, "POST_JSON");

//效果分析
export const effectAnalysis = (data) => request("/report/effectAnalysis", data, "GET");
// 广点通素材报表
export const materialReport_gdt = (data) =>
  request("/tencent/report/materialReport", data, "POST");
